import { Link } from "react-router-dom";

export function Logo({ dark = false, to = "/" }) {
  return (
    <Link to={to} data-testid="logo-link" className="flex items-center gap-2.5 group">
      <div className={`w-8 h-8 rounded-md flex items-center justify-center font-display font-extrabold text-sm tracking-tight ${dark ? "bg-primary-foreground text-primary" : "bg-primary text-primary-foreground"}`}>
        PA
      </div>
      <span className={`font-display font-bold text-lg tracking-tight ${dark ? "text-primary-foreground" : "text-foreground"}`}>
        PAMind
      </span>
    </Link>
  );
}
